import { useTranslation } from "react-i18next";

import { Spinner } from "@/components/ui/spinner";

/**
 * Best practice: let TanStack Router handle pending states via `defaultPendingComponent`
 * (and/or per-route `pendingComponent`). We keep this file to export a single shared UI.
 */

export const SuspenseLoadingScreen = () => {
    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 z-1200 flex flex-col justify-center items-center bg-background/20 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-4">
                <Spinner size="lg" />
                <p className="text-foreground text-base font-medium">{t("loading")}</p>
            </div>
        </div>
    );
};
